import React from 'react'
import { useShippingOptionsAction } from '../hooks/useCheckoutAction'
import { BusyButton } from '@ztechapps/webui.button'
import { Icon } from '@ztechapps/webui.util'

export const ShippingOptionsButton = () => {
  const [onClickShippingOptions] = useShippingOptionsAction()

  return (
    <BusyButton onClick={onClickShippingOptions} text="Checkout">
      <Icon name="chevron-right" />
    </BusyButton>
  )
}
